const extend = function (...modules) {
    return modules.reduce((pre, v) => {
        const { state, actions, mutations, ...others } = v;
        const { state: preState, actions: preActions, mutations: preMutations, ...preOthers } = pre;
        return {
            state: Object.assign({}, preState, state),
            actions: Object.assign({}, preActions, actions),
            mutations: Object.assign({}, preMutations, mutations),
            ...Object.assign({}, preOthers, others)
        }
    }, {}); 
}

export default extend;


// WEBPACK FOOTER //
// ./src/utils/vuex-extend.js